//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/NXObject.js";
import "../no/ugmath.js";
let d=[[[0,"Color",1,0],[0,"IsBlanked",0,0],[0,"Layer",1,0],[0,"LineFont",1,0],[0,"LineWidth",1,0],[0,"NameLocation",0,0],[0,"IsOccurrence",0,0],[0,"JournalIdentifier",0,0],[0,"Name",0,0],[0,"OwningComponent",0,"Assemblies.Component",0],[0,"OwningPart",0,"BasePart",0],[0,"Prototype",0,"INXObject",0]],[[[],"Blank",{},0,0],[[],"Unblank",{},0,0],[[],"Highlight",{},0,0],[[],"Unhighlight",{},0,0],[["location"],"SetNameLocation",{},1,0],[[],"RedisplayObject",{},0,0],[[],"RemoveViewDependency",{},0,0],[["numObjects"],"GetDisplayableObjects",{R_:{objects:"DisplayableObject[]"}},0,0],[["journal_identifier"],"FindObject",{R_:{found:"INXObject"}},1,0],[[],"Print",{},0,0],[["name"],"SetName",{},1,0]],[]];
SPLM.DisplayableObject = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DisplayableObject";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DisplayableObject.ObjectWidth = Object.freeze({
    "Normal" : "Normal", "Thick" : "Thick", "Thin" : "Thin", "One" : "One", "Two" : "Two", "Three" : "Three", "Four" : "Four", "Five" : "Five", "Six" : "Six", "Seven" : "Seven", "Eight" : "Eight", "Nine" : "Nine"});

SPLM.DisplayableObject.ObjectFont = Object.freeze({
    "Solid" : "Solid", "Dashed" : "Dashed", "Phantom" : "Phantom", "Centerline" : "Centerline", "Dotted" : "Dotted", "LongDashed" : "LongDashed", "DottedDashed" : "DottedDashed", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven"});

export default SPLM;